import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { usePageTracking } from "../../hooks/usePageTracking";
import Loader from "../../components/Loader";
import ShareLayout from "./ShareLayout";
import ShareLogin from "./ShareLogin";
import ShareHome from "./ShareHome";
import ShareDashboard from "./ShareDashboard";
import ShareTransferDetail from "./ShareTransferDetail";
import PublicTransferPage from "./PublicTransferPage";
import PublicRequestPage from "./PublicRequestPage";

/** Routes of share.pic-loud.com (rendered by App.js when isShareHost). */
export default function ShareApp() {
  const { authenticated, loadingAuth } = useAuth();
  const location = useLocation();
  usePageTracking();

  if (loadingAuth) return <Loader iconPath="/favicon.png" size={100} />;

  const requireAuth = (element, narrow = false) =>
    authenticated ? (
      <ShareLayout narrow={narrow}>{element}</ShareLayout>
    ) : (
      <Navigate to="/login" replace state={{ from: location.pathname }} />
    );

  return (
    <Routes>
      <Route
        path="/login"
        element={authenticated ? <Navigate to="/" replace /> : <ShareLayout narrow><ShareLogin /></ShareLayout>}
      />
      <Route path="/" element={requireAuth(<ShareHome />, true)} />
      <Route path="/transfers" element={requireAuth(<ShareDashboard />)} />
      <Route path="/transfers/:id" element={requireAuth(<ShareTransferDetail />, true)} />

      {/* Public, token-scoped pages: no account needed */}
      <Route path="/t/:token" element={<PublicTransferPage />} />
      <Route path="/r/:token" element={<PublicRequestPage />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
